export default "__VITE_ASSET__CpEOsmdH__"